/* eslint-disable react-hooks/exhaustive-deps */
// import { zodResolver } from '@hookform/resolvers/zod';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import { Box, Button, Card, CircularProgress, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
// import { useEffect, useState, useCallback } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate, useParams } from 'react-router-dom';
// import showToast from '../../../components/Hot-Toast/showToast';
// import { addRole } from '../../../hooks/validationSchema';
// import { useTMutation } from '../../../utils/useTMutation';
// import { useTQuery } from '../../../utils/useTQuery';

// function AddRole() {
//     const { ID } = useParams();
//     // const dispatch = useDispatch();
//     const { userDetails } = useSelector(state => state?.user);
//     const [userType, setUserType] = useState(userDetails?.USER_TYPE);

//     const navigate = useNavigate();

//     const [menu, setMenu] = useState([]);

//     const {
//         register, control,
//         handleSubmit,
//         formState: { errors },
//         setValue,
//         reset,
//         watch
//     } = useForm({
//         resolver: zodResolver(addRole),
//         defaultValues: {
//             ROLE_NAME: "",
//             DESCRIPTION: "",
//             STATUS: "Active",
//             USER_TYPE: userDetails?.USER_TYPE

//         },
//     });
//     const { data, refetch, isLoading } = useTQuery(
//         ID ? "fetchRole" : "menu",
//         `/role/fetchRoleMenu?${new URLSearchParams({
//             ID: ID || "",
//             USER_TYPE: userType,
//             ROLE_ID: userDetails?.ROLE_ID
//         }).toString()}`,
//         "get",
//         { USER_TYPE: userDetails?.USER_TYPE }
//     );

//     // UseCallback for refetch to avoid unnecessary renders
//     const fetchPermissions = useCallback(() => {
//         refetch();
//     }, [userType, refetch]);

//     // Update state and form only when data changes
//     useEffect(() => {
//         if (data?.OUTPUT) {
//             setMenu(data.OUTPUT?.role_rights || data?.OUTPUT);
//             reset({
//                 ROLE_NAME: ID ? data?.OUTPUT?.ROLE_NAME : "",
//                 DESCRIPTION: ID ? data?.OUTPUT?.DESCRIPTION : "",
//                 STATUS: ID ? data?.OUTPUT?.STATUS : "Active",
//                 USER_TYPE: ID ? data?.OUTPUT?.USER_TYPE : userType,
//             });
//         } else {
//             setMenu([]);
//         }
//     }, [ID, data?.OUTPUT, reset, userType]);

//     // Re-fetch permissions only when userType changes
//     useEffect(() => {
//         fetchPermissions();
//     }, [userType, fetchPermissions]);

//     const { mutateAsync, isPending } = useTMutation("/role/addUpdateRole", "post", (data) => {
//         return data;
//     });

//     const onSubmitNext = async (data) => {

//         try {
//             data.menuRight = menu;
//             if (ID) { data.ID = ID };
//             if (userDetails?.USER_TYPE !== "admin") {
//                 data.PARENT_USER_ID = userDetails?.ID;
//                 data.PARENT_USER_TYPE = userDetails?.USER_TYPE;
//             }
//             const response = await mutateAsync(data);
//             if (response.STATUS) {
//                 showToast("success", response.MESSAGE, 3000);
//                 navigate(`/${userDetails?.USER_TYPE}/roles`);
//             } else {
//                 showToast("error", response.MESSAGE, 3000);
//             }

//         } catch (error) {
//             console.log(error.message);
//             showToast('error', error.message, 3000);
//         }
//     }
//     console.log("menu", menu)
//     return (
//         <>
//             <Box onClick={() => navigate(-1)} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
//                 <IconButton >
//                     <ChevronLeftIcon />
//                 </IconButton>
//                 <Typography variant="body1">Back</Typography>
//             </Box>
//             <Grid container justifyContent={"center"}>

//                 <Card sx={{ boxShadow: "none", padding: "10px 20px", width: "100%" }}>
//                     <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>{ID ? "Edit" : "Add"} Role</Typography>
//                     <form onSubmit={handleSubmit(onSubmitNext)}>
//                         <Grid container spacing={2}>
//                             {userDetails?.USER_TYPE === "admin" && (
//                                 <Grid item xs={12} md={6} lg={4} >
//                                     <FormControl fullWidth sx={{ marginTop: 2 }} error={!!errors.USER_TYPE}>
//                                         <InputLabel id="user-type">User Type</InputLabel>
//                                         <Controller
//                                             name="USER_TYPE"
//                                             control={control}
//                                             render={({ field }) => (
//                                                 <Select
//                                                     disabled={ID}
//                                                     labelId="user-type"
//                                                     id="user-select"
//                                                     label="User Type"
//                                                     {...field}
//                                                     {...register("USER_TYPE")}
//                                                     value={watch("USER_TYPE")}
//                                                     error={!!errors.USER_TYPE}
//                                                     onChange={(e) => {
//                                                         setUserType(e.target.value)
//                                                     }}
//                                                     defaultValue={field.value || ''} // Ensure preselection
//                                                     sx={{
//                                                         '& .MuiOutlinedInput-input': {
//                                                             padding: 1.9
//                                                         },
//                                                     }}
//                                                 >
//                                                     <MenuItem value="admin">Admin</MenuItem>
//                                                     <MenuItem value="facility">Facility</MenuItem>
//                                                     <MenuItem value="clinician">Clinician</MenuItem>
//                                                 </Select>
//                                             )}
//                                         />
//                                         {errors.USER_TYPE && <FormHelperText>{errors.USER_TYPE?.message}</FormHelperText>}
//                                     </FormControl>
//                                 </Grid>
//                             )}
//                         </Grid>
//                         <Grid item xs={12} md={6} lg={4}>
//                             <TextField
//                                 autoFocus
//                                 label="Role Name"
//                                 variant="outlined"
//                                 fullWidth
//                                 margin="normal"
//                                 inputProps={{ maxLength: 30, }}
//                                 // InputProps={{ style: { height: '50px' } }}
//                                 {...register("ROLE_NAME")}
//                                 value={watch("ROLE_NAME")}
//                                 placeholder="Role Name"
//                                 error={!!errors.ROLE_NAME}
//                                 helperText={errors.ROLE_NAME?.message}
//                                 sx={{
//                                     '& .MuiOutlinedInput-input': {
//                                         padding: 1.814
//                                     },
//                                 }}
//                             /></Grid>

//                         <Grid item lg={4}>
//                             <TextField
//                                 label="Description"
//                                 variant="outlined"
//                                 fullWidth
//                                 margin="normal"
//                                 // InputProps={{ style: { height: '50px' } }}
//                                 {...register("DESCRIPTION")}
//                                 value={watch("DESCRIPTION")}
//                                 placeholder="Description"
//                                 error={!!errors.DESCRIPTION}
//                                 helperText={errors.DESCRIPTION?.message}
//                                 sx={{
//                                     '& .MuiOutlinedInput-input': {
//                                         padding: 1.814
//                                     },
//                                 }}
//                             />

//                         </Grid>

//                         {userDetails?.USER_TYPE === "admin" && <Grid item xs={12} md={6} lg={4}>
//                             <FormControl fullWidth sx={{ marginTop: 2 }} error={!!errors.EXP_JOBROLE_ID}>
//                                 <InputLabel id="user-type">User Type</InputLabel>
//                                 <Controller
//                                     name="User Type"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <Select

//                                             labelId="user-type"
//                                             id="user-select"
//                                             label="User Type"
//                                             {...field}
//                                             {...register("USER_TYPE")}
//                                             value={watch("USER_TYPE")}
//                                             error={!!errors.USER_TYPE}
//                                             onChange={(e) => {
//                                                 setUserType(e.target.value)

//                                             }}
//                                             defaultValue={field.value || ''} // Ensure preselection
//                                             sx={{
//                                                 '& .MuiOutlinedInput-input': {
//                                                     padding: 1.814
//                                                 },
//                                             }}

//                                         >
//                                             <MenuItem value="admin">Admin</MenuItem>
//                                             <MenuItem value="facility">Facility</MenuItem>
//                                             <MenuItem value="clinician">Clinician</MenuItem>
//                                         </Select>
//                                     )}
//                                 />
//                                 {errors.USER_TYPE && <FormHelperText>{errors.USER_TYPE?.message}</FormHelperText>}
//                             </FormControl>

//                             <Grid item xs={12} md={6} lg={4}>
//                                 <FormControl fullWidth sx={{ marginTop: 2 }} error={!!errors.STATUS}>
//                                     <InputLabel id="status">Status</InputLabel>
//                                     <Controller
//                                         name="STATUS"
//                                         control={control}
//                                         render={({ field }) => (
//                                             <Select
//                                                 labelId="status"
//                                                 id="status-select"
//                                                 label="Status"
//                                                 {...field}
//                                                 value={watch("STATUS")}
//                                                 {...register("STATUS")}

//                                                 error={!!errors.STATUS}
//                                                 defaultValue={field.value || ''} // Ensure preselection
//                                                 sx={{
//                                                     '& .MuiOutlinedInput-input': {
//                                                         padding: 1.814
//                                                     },
//                                                 }}
//                                             >
//                                                 <MenuItem value="Active">Active</MenuItem>
//                                                 <MenuItem value="Inactive">Inactive</MenuItem>

//                                             </Select>
//                                         )}
//                                     />
//                                     {errors.STATUS && <FormHelperText>{errors.STATUS?.message}</FormHelperText>}
//                                 </FormControl>

//                             </Grid>
//                         </Grid>
//                         }
//                         <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px", marginTop: "3px" }}>{ID ? "Edit" : "Add"} Permission</Typography>
//                         {isLoading ? (
//                             <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginTop: 2 }}>
//                                 <CircularProgress />
//                             </Box>
//                         ) : (
//                             <Grid container spacing={2}>
//                                 {menu && menu.map((val, i) => (
//                                     <Grid item lg={4} key={i}>
//                                         <FormControl fullWidth sx={{ marginTop: 2 }} error={!!errors.EXP_JOBROLE_ID}>
//                                             <InputLabel id={`screen-right-${i}`}>{val?.SCREEN_NAME}</InputLabel>
//                                             <Controller
//                                                 name={`STATUS-${i}`}
//                                                 control={control}
//                                                 render={({ field }) => (
//                                                     <Select
//                                                         labelId={`screen-right-${i}`}
//                                                         id={`right-select-${i}`}
//                                                         label={val?.SCREEN_NAME}
//                                                         {...field}
//                                                         value={val?.SCREEN_RIGHT || "Full Access"}
//                                                         onChange={(e) => {
//                                                             let menuData = [...menu];
//                                                             menuData[i].SCREEN_RIGHT = e.target.value;
//                                                             setMenu(menuData);
//                                                         }}

//                                                         defaultValue={field.value || 'Full Access'}
//                                                         sx={{
//                                                             '& .MuiOutlinedInput-input': {
//                                                                 padding: 1.9
//                                                             },
//                                                         }}
//                                                     >
//                                                         <MenuItem value="Full Access">Full Access</MenuItem>
//                                                         <MenuItem value="View Only">View Only</MenuItem>
//                                                         <MenuItem value="None">None</MenuItem>
//                                                     </Select>
//                                                 )}
//                                             />

//                                         </FormControl>
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         )}
//                         <Box display="flex" justifyContent="end" alignItems="center" style={{ marginTop: 20 }}>
//                             <Button
//                                 variant="contained"
//                                 sx={{ background: "#6EBE44" }}
//                                 className='submitbtn'
//                                 type="submit"
//                                 disabled={isPending}
//                             >
//                                 {isPending ? <CircularProgress size={24} /> : ID ? "Update" : "Submit"}
//                             </Button>
//                         </Box>

//                     </form>
//                 </Card>

//             </Grid>

//         </>
// z    );
// }

// export default AddRole;

import { zodResolver } from "@hookform/resolvers/zod";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState, useCallback, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import showToast from "../../../components/Hot-Toast/showToast";
import { addRole } from "../../../hooks/validationSchema";
import { useTMutation } from "../../../utils/useTMutation";
import { useTQuery } from "../../../utils/useTQuery";
import { getScreenUsageMap } from "../../../routes/Router";

function AddRole() {
  const { ID } = useParams();
  const { userDetails } = useSelector((state) => state?.user);
  const [userType, setUserType] = useState(userDetails?.USER_TYPE);
  const navigate = useNavigate();
  const [menu, setMenu] = useState([]);
  const [initialFullAccessPermissions, setInitialFullAccessPermissions] = useState(new Set());

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: zodResolver(addRole),
    defaultValues: {
      ROLE_NAME: "",
      DESCRIPTION: "",
      STATUS: "Active",
      USER_TYPE: userDetails?.USER_TYPE,
    },
  });

  const { data, refetch, isLoading } = useTQuery(
    ID ? "fetchRole" : "menu",
    `/role/fetchRoleMenu?${new URLSearchParams({
      ID: ID || "",
      USER_TYPE: userType,
      ROLE_ID: userDetails?.ROLE_ID,
    }).toString()}`,
    "get",
    { USER_TYPE: userDetails?.USER_TYPE }
  );

  const fetchPermissions = useCallback(() => {
    refetch();
  }, [userType, refetch]);

  const FULL_ACCESS_RULES = {
    admin: ["AdminDashboard"],
    clinician: ["Clinician Profile"],
    facility: ["Facility"],
  };

  useEffect(() => {
    if (!data?.OUTPUT) {
      setMenu([]);
      return;
    }

    const roleRights =
      data?.OUTPUT?.role_rights ?? data?.OUTPUT ?? [];

    const updatedMenu = roleRights.map((opt) => {
      const mustHaveFullAccess =
        FULL_ACCESS_RULES[userType]?.includes(opt?.SCREEN_NAME);

      return {
        ...opt,
        SCREEN_RIGHT: mustHaveFullAccess
          ? "Full Access"
          : opt?.SCREEN_RIGHT || "None",
      };
    });

    console.log(updatedMenu)
    setMenu(updatedMenu);

    if (ID) {
      // Only restrict Full Access permissions for regular users, not for admin or facility users
      const initialFullAccess = (userDetails?.USER_TYPE !== "admin" && userDetails?.USER_TYPE !== "facility") ? new Set(
        updatedMenu
          .map((item, index) => ({ item, index }))
          .filter(({ item }) => item.SCREEN_RIGHT === "Full Access")
          .map(({ index }) => index)
      ) : new Set(); // Empty set for admins and facilities - no restrictions
      setInitialFullAccessPermissions(initialFullAccess);
    }

    reset({
      ROLE_NAME: ID ? data?.OUTPUT?.ROLE_NAME : "",
      DESCRIPTION: ID ? data?.OUTPUT?.DESCRIPTION : "",
      STATUS: ID ? data?.OUTPUT?.STATUS : "Active",
      USER_TYPE: ID ? data?.OUTPUT?.USER_TYPE : userType,
    });

    setUserType(ID ? data?.OUTPUT?.USER_TYPE : userType)

  }, [ID, data?.OUTPUT, reset]);

  useEffect(() => {
    fetchPermissions();
  }, [userType, fetchPermissions]);

  const { mutateAsync, isPending } = useTMutation(
    "/role/addUpdateRole",
    "post",
    (data) => {
      return data;
    }
  );

  // Get screen usage map
  const screenUsageMap = useMemo(() => {
    return getScreenUsageMap();
  }, []);

  const onSubmitNext = async (data) => {
    try {
      data.menuRight = menu;
      if (ID) {
        data.ID = ID;
      }
      if (userDetails?.USER_TYPE !== "admin") {
        data.PARENT_USER_ID = userDetails?.ID;
        data.PARENT_USER_TYPE = userDetails?.USER_TYPE;
      }
      const response = await mutateAsync(data);
      if (response.STATUS) {
        showToast("success", response.MESSAGE, 3000);
        navigate(`/${userDetails?.USER_TYPE}/roles`);
      } else {
        showToast("error", response.MESSAGE, 3000);
      }
    } catch (error) {
      console.log(error.message);
      showToast("error", error.message, 3000);
    }
  };

  const isForcedFullAccess = (item) =>
    FULL_ACCESS_RULES[userType]?.includes(item?.SCREEN_NAME);

  //   const screenUsageMap = useMemo(() => {
  //   const map = {};

  //   routes.forEach((route) => {
  //     if (!map[route.screenRight]) {
  //       map[route.screenRight] = new Set();
  //     }
  //     map[route.screenRight].add(route.title);
  //   });

  //   // convert Set → Array
  //   Object.keys(map).forEach((key) => {
  //     map[key] = Array.from(map[key]);
  //   });

  //   return map;
  // }, []);

  return (
    <>
      <Box
        onClick={() => navigate(-1)}
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      >
        <IconButton>
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="body1">Back</Typography>
      </Box>
      <Grid container justifyContent={"center"}>
        <Card sx={{ boxShadow: "none", padding: "10px 20px", width: "100%" }}>
          <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>
            {ID ? "Edit" : ""} Role
          </Typography>
          <form onSubmit={handleSubmit(onSubmitNext)}>
            <Grid container spacing={2}>
              {userDetails?.USER_TYPE === "admin" && (
                <Grid item lg={4}>
                  <FormControl
                    fullWidth
                    sx={{ marginTop: 2 }}
                    error={!!errors.USER_TYPE}
                  >
                    <InputLabel id="user-type">User Type</InputLabel>
                    <Controller
                      name="USER_TYPE"
                      control={control}
                      render={({ field }) => (
                        <Select
                          disabled={ID}
                          labelId="user-type"
                          id="user-select"
                          label="User Type"
                          {...field}
                          {...register("USER_TYPE")}
                          value={watch("USER_TYPE")}
                          error={!!errors.USER_TYPE}
                          onChange={(e) => {
                            setUserType(e.target.value);
                          }}
                          sx={{
                            "& .MuiOutlinedInput-input": {
                              padding: 1.9,
                            },
                          }}
                        >
                          <MenuItem value="admin">Admin</MenuItem>
                          <MenuItem value="facility">Facility</MenuItem>
                          <MenuItem value="clinician">Clinician</MenuItem>
                        </Select>
                      )}
                    />
                    {errors.USER_TYPE && (
                      <FormHelperText>
                        {errors.USER_TYPE?.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              )}

              <Grid item lg={4}>
                <TextField
                  autoFocus
                  label="Role Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  inputProps={{ maxLength: 30 }}
                  // InputProps={{ style: { height: '50px' } }}
                  {...register("ROLE_NAME")}
                  value={watch("ROLE_NAME")}
                  placeholder="Role Name"
                  error={!!errors.ROLE_NAME}
                  helperText={errors.ROLE_NAME?.message}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      padding: 1.814,
                    },
                  }}
                />
              </Grid>

              <Grid item lg={4}>
                <TextField
                  label="Description"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  // InputProps={{ style: { height: '50px' } }}
                  {...register("DESCRIPTION")}
                  value={watch("DESCRIPTION")}
                  placeholder="Description"
                  error={!!errors.DESCRIPTION}
                  helperText={errors.DESCRIPTION?.message}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      padding: 1.814,
                    },
                  }}
                />
              </Grid>

              <Grid item lg={4}>
                <FormControl
                  fullWidth
                  sx={{ marginTop: 2 }}
                  error={!!errors.STATUS}
                >
                  <InputLabel id="status">Status</InputLabel>
                  <Controller
                    name="STATUS"
                    control={control}
                    render={({ field }) => (
                      <Select
                        labelId="status"
                        id="status-select"
                        label="Status"
                        {...field}
                        value={watch("STATUS")}
                        error={!!errors.STATUS}
                        sx={{
                          "& .MuiOutlinedInput-input": {
                            padding: 1.814,
                          },
                        }}
                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    )}
                  />
                  {errors.STATUS && (
                    <FormHelperText>{errors.STATUS?.message}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            <Typography
              gutterBottom
              sx={{ fontWeight: 600, fontSize: "24px", marginTop: "20px" }}
            >
              {ID ? "Edit" : "Add"} Permission
            </Typography>

            {isLoading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ marginTop: 2 }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Grid container spacing={2}>
                {menu &&
                  menu.map((val, i) => (
                    <Grid item lg={4} key={i}>
                      <Tooltip
                        title={
                          initialFullAccessPermissions.has(i)
                            ? "This permission is locked because it has Full Access. Contact administrator to modify."
                            : ""
                        }
                        placement="top"
                      >
                        <FormControl
                          fullWidth
                          sx={{ marginTop: 2 }}
                          error={!!errors.EXP_JOBROLE_ID}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                            <InputLabel id={`screen-right-${i}`} sx={{ m: 0, position: 'relative', transform: 'none', fontSize: '0.875rem' }}>
                              {val?.SCREEN_NAME}
                            </InputLabel>
                            {screenUsageMap[val?.SCREEN_NAME] && screenUsageMap[val?.SCREEN_NAME].length > 0 && (
                              <Tooltip
                                title={
                                  <Box sx={{ whiteSpace: 'pre-wrap' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
                                      Pages using this permission:
                                    </Typography>
                                    {screenUsageMap[val?.SCREEN_NAME].map((item, idx) => (
                                      <Typography key={idx} variant="caption" sx={{ display: 'block', mb: 0.3 }}>
                                        • {item.title || item.path}
                                      </Typography>
                                    ))}
                                  </Box>
                                }
                                placement="top"
                                arrow
                              >
                                <InfoIcon sx={{ fontSize: '1rem', cursor: 'pointer', color: '#0288d1', '&:hover': { color: '#0277bd' } }} />
                              </Tooltip>
                            )}
                          </Box>
                          <Select
                            key={`select-${i}-${val?.SCREEN_RIGHT}`}
                            labelId={`screen-right-${i}`}
                            id={`right-select-${i}`}
                            label={val?.SCREEN_NAME}
                            value={val?.SCREEN_RIGHT || "None"}
                            onChange={(e) => {
                              setMenu(prevMenu => prevMenu.map((item, index) =>
                                index === i ? { ...item, SCREEN_RIGHT: e.target.value } : item
                              ));
                            }}
                            disabled={initialFullAccessPermissions.has(i)}
                            sx={{
                              "& .MuiOutlinedInput-input": {
                                padding: 1.9,
                              },
                              "& .MuiOutlinedInput-root": {
                                opacity: initialFullAccessPermissions.has(i) ? 0.6 : 1, // Gray out disabled fields
                              },
                            }}
                          >
                            <MenuItem value="Full Access">
                              Full Access
                            </MenuItem>
                            <MenuItem value="View Only" disabled={isForcedFullAccess(val)}>View Only</MenuItem>
                            <MenuItem value="None" disabled={isForcedFullAccess(val)}>None</MenuItem>
                          </Select>
                        </FormControl>
                      </Tooltip>
                    </Grid>
                  ))}
              </Grid>
            )}
            <Box
              display="flex"
              justifyContent="end"
              alignItems="center"
              style={{ marginTop: 20 }}
            >
              <Button
                variant="contained"
                sx={{ background: "#6EBE44" }}
                className="submitbtn"
                type="submit"
                disabled={isPending}
              >
                {/* {isPending ? <CircularProgress size={24} /> : ID ? "Update" : "Submit"} */}
                {isPending ? (
                  <CircularProgress size={24} />
                ) : ID ? (
                  "Update"
                ) : (
                  "Next"
                )}
              </Button>
            </Box>
          </form>
        </Card>
      </Grid>
    </>
  );
}

export default AddRole;
